<tt-page>
    <tt-page-heading class="col-xs-12 sp-0"> <span ttTranslateWord="p2_m_saftexport"></span></tt-page-heading>
    <div class="col-xs-12 sp-0 flex-1" style="display: flex">
        <tt-select class="col-xs-12 sp-0" tt-label="businessco" [(ttModel)]="model.businesscoNo" (ttModelChange)="businesscoChanged()" tt-data="model.businesscoList" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
        <!--<tt-date-range tt-label="date_fom_tom" tt-start-date="vm.model.setting.date_fom" tt-end-date="vm.model.setting.date_tom" tt-date-index="vm.model.setting.dateselector_index" tt-change="vm.onDateRangeChanged($startDate, $endDate, $dateIndex)"></tt-date-range>-->
    </div>
</tt-page>
